import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ReminderDataInterface } from 'src/app/models/reminder-data.interface';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormFocusDirective } from '../../../core/directives/form-focus.directive';

@Component({
    selector: 'app-reminder-action-display-notification-data',
    templateUrl: './reminder-action-display-notification-data.component.html',
    styleUrls: ['./reminder-action-display-notification-data.component.scss'],
    imports: [FormsModule, FormFocusDirective, ReactiveFormsModule, MatFormFieldModule, MatInputModule]
})
export class ReminderActionDisplayNotificationDataComponent implements ReminderDataInterface, OnInit {
    public _data: string;

    set data(value: string) {
        this._data = value;
        this.fillForm();
    }

    get data(): string {
        this.fillData();
        return this._data;
    }

    public dataForm: UntypedFormGroup;

    constructor() {}

    ngOnInit(): void {
        this.dataForm = new UntypedFormGroup({
            titleForm: new UntypedFormControl(null, [Validators.required]),
            textForm: new UntypedFormControl(null, [Validators.required]),
        });

        this.fillForm();
    }

    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                let dataObject = JSON.parse(this._data);

                this.dataForm.get('titleForm').setValue(dataObject.title);
                this.dataForm.get('textForm').setValue(dataObject.text);
            }
        }
    }

    private fillData() {
        let dataObject: any = {};
        dataObject.title = this.dataForm.get('titleForm').value;
        dataObject.text = this.dataForm.get('textForm').value;

        this._data = JSON.stringify(dataObject);
    }

    public isValid(): boolean {
        return this.dataForm?.valid;
    }
}
